/**
 * @file Album subscription purchase.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import withModal from '../global/modal/withModal';
import { SUBSCRIPTION_DESC_MODAL } from '../../constants/modals';
import Button from '../global/Button';
import { formatPriceForDisplay } from '../../util/format-money';
import { getAlbumPrice } from '../../util/purchase-album';
import {
  getAlbumCustomPrint,
  getAlbumCustomPrintBundlePrice,
  getAlbumCustomPrintName,
} from '../../util/custom-prints';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  purchaseUrl: PropTypes.string,
  onRequestClose: PropTypes.func.isRequired,
  onSubscriptionPurchase: PropTypes.func.isRequired,
  onCustomPrintPurchase: PropTypes.func.isRequired,
};

const SubscriptionDescriptionModal = ({
  album,
  purchaseUrl,
  onRequestClose,
  onSubscriptionPurchase,
  onCustomPrintPurchase,
}) => {
  const price = getAlbumPrice(album);
  const albumCustomPrint = getAlbumCustomPrint(album);
  const albumCustomPrintPrice = getAlbumCustomPrintBundlePrice(
    albumCustomPrint,
  );
  const redirectPath = purchaseUrl
    ? {
        pathname: purchaseUrl,
        state: { fromUpsell: true },
      }
    : undefined;
  const getJoinTypeWording = () => {
    const subscriptionAlbumFolderName = get(
      album,
      'subscription_album_folder.name',
    );

    return subscriptionAlbumFolderName || 'this event';
  };

  return (
    <div className="p-1">
      <h4 className="text-base">What&rsquo;s a &ldquo;Photo Pass&rdquo;?</h4>

      <p>
        It&rsquo;s a subscription to all your photos for{' '}
        <strong>{getJoinTypeWording()}</strong>. Every time Waldo finds you in a
        photo, you&rsquo;ll get an alert so you can view, download and share
        &ndash; all from the app.
      </p>

      <p>
        You&rsquo;ll also get to invite family members to your photo stream,
        which means your family can get the same alerts and pics!
      </p>

      <Button
        btnBlock
        className="mt-3"
        to={redirectPath}
        onClick={() => {
          onSubscriptionPurchase();
          onRequestClose();
        }}
      >
        Buy now ($
        {formatPriceForDisplay(price)})
      </Button>

      {albumCustomPrint && albumCustomPrintPrice != null && (
        <Fragment>
          <Button
            btnBlock
            btnStyle="yellow"
            to={redirectPath}
            onClick={() => {
              onSubscriptionPurchase();
              onCustomPrintPurchase();
              onRequestClose();
            }}
          >
            Buy with {getAlbumCustomPrintName(albumCustomPrint)} ($
            {formatPriceForDisplay(price + albumCustomPrintPrice)})
          </Button>
        </Fragment>
      )}

      {get(album, 'root_album_folder.day_pricings_enabled') && (
        <div className="text-center text-sm mt-2">
          * Discount for additional events added at checkout
        </div>
      )}

      <div className="mt-2 text-center">
        <Button btnBlock btnStyle="link" onClick={onRequestClose}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

SubscriptionDescriptionModal.propTypes = propTypes;

export default withModal(SubscriptionDescriptionModal, {
  name: SUBSCRIPTION_DESC_MODAL,
  size: 'sm',
  hideHeader: true,
});
